import { render, staticRenderFns } from "./registerUserDetail.vue?vue&type=template&id=05b4047c&scoped=true"
import script from "./registerUserDetail.vue?vue&type=script&lang=js"
export * from "./registerUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4047c",
  null
  
)

export default component.exports